import { useEffect } from 'react'
import useContent from '../utils/content'
import { useDataQuery } from './useDataQuery'

const hexToRGB = color => ({
  r: parseInt(color.substr(1, 2), 16),
  g: parseInt(color.substr(3, 2), 16),
  b: parseInt(color.substr(5, 2), 16)
})

const useCssVariables = () => {
  const content = useContent(useDataQuery())

  useEffect(() => {
    const backgroundRgb = hexToRGB(content.backgroundColor)
    document.documentElement.style.setProperty(
      '--background-color',
      content.backgroundColor
    )
    document.documentElement.style.setProperty(
      '--background-color-transparent',
      `rgba(${backgroundRgb.r}, ${backgroundRgb.g}, ${backgroundRgb.b}, 0.9)`
    )
    document.documentElement.style.setProperty(
      '--title-color',
      content.titleColor
    )
  }, [])
}

export default useCssVariables
